import React, { forwardRef } from 'react'
import './checkbox.styles.css'
import { cn } from 'components/UI/cn'

const Checkbox = forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & {
    boxSize?: 'sm' | 'md' | 'lg'
    wrapperClassName?: string
  }
>(
  (
    props: React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    > & {
      boxSize?: 'sm' | 'md' | 'lg'
      wrapperClassName?: string
    },
    ref
  ) => {
    const { wrapperClassName, boxSize, ...rest } = props
    return (
      <label
        className={cn('custom-checkbox ', wrapperClassName, {
          'cursor-pointer': !rest.disabled,
        })}
      >
        <input type="checkbox" {...rest} ref={ref} />
        <span className={`checkmark checkmark-${boxSize ?? 'md'} `}></span>
      </label>
    )
  }
)
Checkbox.displayName = 'Checkbox'

export default Checkbox
